/** Build tracking URL from partner template and AWB. Placeholders: {tracking}, {number}, {awb} */
export function buildTrackingUrlFromTemplate(template, trackingNumber) {
  const tn = String(trackingNumber || '').trim();
  const tpl = String(template || '').trim();
  if (!tn || !tpl || !/^https?:\/\//i.test(tpl)) return '';
  const encoded = encodeURIComponent(tn);
  let url = tpl.replace(/\{tracking\}/gi, encoded).replace(/\{number\}/gi, encoded).replace(/\{awb\}/gi, encoded);
  if (url === tpl && !url.includes(tn)) {
    url += (url.includes('?') ? '&' : '?') + `awb=${encoded}`;
  }
  return url;
}

export function partnerById(partners, id) {
  const slug = String(id || '').trim();
  if (!slug) return null;
  return (partners || []).find((p) => p.id === slug) || null;
}

export function emptyPartnerDraft() {
  return { id: '', name: '', url_template: '' };
}
